import { styled } from "@mui/material/styles";

export const Section = styled("section", {
  label: "section",
})`
  flex: 1;

  & + & {
    margin-top: 0;
    border-top: 1px solid ${({ theme }) => theme.palette.color.gray[80]};
    ${({ theme }) => theme.breakpoints.up("md")} {
      border-top: none;
    }
  }

  &.colored {
    background-color: ${({ theme }) => theme.palette.color.primary[110]};
    border-radius: 32px;
    padding: ${({ theme }) => theme.spacing(3.5)};
    margin-top: ${({ theme }) => theme.spacing(1.5)};
    border-top: none;
  }
`;

export const SectionTitle = styled("h3", {
  label: "section-title",
})`
  font-size: 24px;
  font-weight: 400;
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.color.primary.main};
  padding: 0;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 28px;
    font-weight: 500;
  }
`;

export const SectionContent = styled("div", {
  label: "section-content",
})`
  padding: ${({ theme }) => theme.spacing(1, 0)};
  &:last-of-type & {
    padding-bottom: 0;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: ${({ theme }) => theme.spacing(1, 0, 0)};
  }
`;

export const SectionBody = styled("div", {
  label: "section-body",
})`
  flex: 1;
  box-shadow: none;
  padding: 0;
  background-color: transparent;

  &::before {
    content: none;
  }
`;
